var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.78996 6.00002C7.78996 6.99002 6.98996 7.79002 5.99996 7.79002C5.00996 7.79002 4.20996 6.99002 4.20996 6.00002C4.20996 5.01002 5.00996 4.21002 5.99996 4.21002C6.98996 4.21002 7.78996 5.01002 7.78996 6.00002Z",
    stroke: "#1D2023",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99992 10.135C7.76492 10.135 9.40992 9.09499 10.5549 7.29499C11.0049 6.58999 11.0049 5.40499 10.5549 4.69999C9.40992 2.89999 7.76492 1.85999 5.99992 1.85999C4.23492 1.85999 2.58992 2.89999 1.44492 4.69999C0.994922 5.40499 0.994922 6.58999 1.44492 7.29499C2.58992 9.09499 4.23492 10.135 5.99992 10.135Z",
    stroke: "#1D2023",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.43e84e4a875f7f9bf46e8999196b81ef.svg";
export { ForwardRef as ReactComponent };